import { cn } from '@/lib/cn'

type StatCardProps = {
  label: string
  value: string | number
  delta?: {
    value: string
    trend: 'up' | 'down' | 'steady'
  }
  icon?: React.ReactNode
  className?: string
}

const trendStyles = {
  up: 'text-success-300',
  down: 'text-danger-300',
  steady: 'text-slate-300',
} as const

export function StatCard({ label, value, delta, icon, className }: StatCardProps) {
  return (
    <div
      className={cn(
        'card relative overflow-hidden transition hover:-translate-y-1 hover:shadow-elevated',
        className,
      )}
    >
      <div className="absolute -right-12 -top-12 h-32 w-32 rounded-full bg-brand-500/10" />
      <div className="relative flex flex-col gap-3 p-6 md:p-7">
        <div className="flex items-center justify-between text-slate-300">
          <span className="stat-label">{label}</span>
          {icon ? <span className="text-brand-300/80">{icon}</span> : null}
        </div>
        <div className="stat-value">{value}</div>
        {delta ? (
          <span className={cn('text-xs font-medium', trendStyles[delta.trend])}>{delta.value}</span>
        ) : null}
      </div>
    </div>
  )
}
